import { render, staticRenderFns } from "./DrawerInvoice.vue?vue&type=template&id=5616532a&"
import script from "./DrawerInvoice.vue?vue&type=script&lang=ts&"
export * from "./DrawerInvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5616532a')) {
      api.createRecord('5616532a', component.options)
    } else {
      api.reload('5616532a', component.options)
    }
    module.hot.accept("./DrawerInvoice.vue?vue&type=template&id=5616532a&", function () {
      api.rerender('5616532a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ArAgingReminder/DrawerInvoice.vue"
export default component.exports